export const ACTIVITY_TYPE = {
  COMMENT: 'comment',
  MODEL: 'model',
  PIPELINE: 'pipeline',
};

export const WALLAROO_OPS_CENTER_REGEX = 'regex:engine.*';
